// extracted by mini-css-extract-plugin
module.exports = {"action":"_2gigc","mobile":"gp8K1","list":"DjgT5"};